import type { DailyStrikeScreenModel } from './DailyStrikeScreenModelScreen';

export class DailyStrikeScreenController {
  constructor(private readonly model: DailyStrikeScreenModel) {}

  handleGoBack = () => {
    this.model.onGoBack?.();
  };
}
